import { EvidenceLine } from '@/components/companion/cards/CompanionCardShell';
import { companionEvidenceLines } from '@/components/companion/feed/companion-evidence-lines';
import { Stack, Text } from '@chakra-ui/react';
import type { CompanionActionDto } from '@fluenceur/types';
import { useTranslation } from 'react-i18next';

/**
 * Why this card exists, in the evidence's own terms.
 *
 * The panel shows what the detector recorded and where it came from, so a
 * brand can disagree with the companion on facts rather than on a feeling.
 */

interface CompanionWhyPanelProps {
  action: CompanionActionDto;
}

export const CompanionWhyPanel = ({ action }: CompanionWhyPanelProps) => {
  const { t, i18n } = useTranslation();
  const lines = companionEvidenceLines(action.evidence, t, i18n?.language ?? 'en');

  return (
    <Stack
      gap="6px"
      p="12px 14px"
      bg="softCream"
      borderRadius="10px"
      data-testid="companion-why-panel"
    >
      {action.narration ? <EvidenceLine>{action.narration.text}</EvidenceLine> : null}
      {lines.map((line) => (
        <EvidenceLine key={line}>{line}</EvidenceLine>
      ))}
      <Text fontSize="11.5px" color="inkSubtle" mt="2px">
        {t('companion.panel.why.source', {
          source: t(`companion.panel.why.sources.${action.kind}`),
        })}
      </Text>
    </Stack>
  );
};
